<template>
  <div>
    <b-form-checkbox v-model="checked" name="check-button" switch>
      Internal Message
    </b-form-checkbox>
  </div>
</template>

<script>
import { BFormCheckbox } from "bootstrap-vue";

export default {
  name: "CSwitch",
  components: {
    BFormCheckbox,
  },
  data() {
    return {
      checked: false,
    };
  },
  watch: {
    checked(newVal, oldVal) {
      if (newVal !== oldVal) this.$emit("checked", newVal);
    },
  },
};
</script>
